/**
 * Normalises a metrics score for rendering.
 *
 * The API distinguishes three states and so must the UI:
 * - `number`   a real score. Capped at 100 as defense in depth against a backend
 *              ratio above 1 (see apps/backend/src/repositories/product/README.md).
 * - `null`     the scope has no scored questions at all - every question in it was
 *              answered N/A. There is no score to show, so this must render as N/A,
 *              never as 0%.
 * - `undefined` the metric has not loaded yet. Kept as the pre-existing 0 placeholder
 *              so a loading dashboard looks exactly as it always has.
 */
// eslint-disable-next-line import/prefer-default-export
export const toDisplayScore = (score: number | null | undefined): number | null => (
  score === null ? null : Math.min(score ?? 0, 100)
)
